// removed by extract-text-webpack-plugin
module.exports = {"container":"_2l3Cw","avatar":"_2V8Oj","content":"_2Z6uX"};


//////////////////
// WEBPACK FOOTER
// ./app/components/member-confirmation/member-confirmation.scss
// module id = 917
// module chunks = 3 4 5 6 7